export interface OptionItem<ValueType = any> {
	label: string;
	value: ValueType;
	styleClass?: string;
	icon?: string;
	title?: string;
	disabled?: boolean;
}
